<div
  class="relative w-[3.5rem] h-[22px] flex items-center bg-white border rounded-full p-1 cursor-pointer"
  [ngClass]="{'bg-[#71AF04] border-[#71AF04]': checked, 'border-gray-500': !checked }"
  (click)="toggle()"
>
  <div
    class="w-3.5 h-3.5 rounded-full shadow-md transform transition-transform duration-300"
    [ngClass]="{ 'translate-x-8 bg-[#71AF04]': checked, 'translate-x-0 bg-gray-500': !checked }"
  ></div>
</div>
